const type = 'SET_ACCOUNT_PROGRAM_TYPES_LIST';

const setAccountProgramTypesList = (data = {}) => ({
  data,
  type,
});

export { type };
export default setAccountProgramTypesList;
